import type { ThemeKey, DefaultThemeStyles } from 'Src/types/theme';
import type { ReactNode } from 'react';
import React, { Fragment } from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import ratioUtils from 'Components/utils/ratios/ratios.utils';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ImagePlaceholder } from 'Components/frameworks/image-placeholder/ImagePlaceholder';
import { themes } from './AdditionItemIcon.themes';
type AdditionItemIconProps = {
  alt?: string;
  iconName?: IconName;
  label?: string;
  ratioKey?: MediaRatios;
  symbol?: ReactNode;
  theme?: ThemeKey<typeof themes>;
};
export const AdditionItemIcon = ({
  alt,
  iconName,
  label,
  symbol,
  ratioKey = ratioUtils.XL,
  theme = 'default',
}: AdditionItemIconProps) => {
  if (!iconName) {
    return null;
  }

  const { thItemIcon, thItemIconSize, thItemLabel } = themes[theme] as DefaultThemeStyles<
    typeof themes
  >;
  return (
    <Fragment>
      <ImagePlaceholder aspectRatio={100 * ratioUtils.VALUES[ratioKey]}>
        <span className={thItemIcon}>
          <Icon name={iconName} isNotSquare width={thItemIconSize} />
        </span>
        {symbol}
      </ImagePlaceholder>
      {alt && <span className="sr-only">{alt} </span>}
      {!!label && (
        <span className={thItemLabel} data-testid="AdditionItemIcon-label">
          {label}
          <Icon hasRtl name={ICONS.ARROW_RIGHT} width="1em" />
        </span>
      )}
    </Fragment>
  );
};
